<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(sm12, md11, lg9, xl7, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat).centerCard
            breadcrumb(back='page10-1')
              | Estás en: Elige tu Crédito Hipotecario / ¿Qué aprendí en esta lección?
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 1 DE 4
            img.pt-3(style="width:61px; heigth:67px;", src="assets/cronometro.gif")
            v-card-text.chrono
              b {{("0" + Math.floor(time / 60)).slice(-2) +":" + ("0"+(time - Math.floor(time / 60) * 60)).slice(-2)}}
            v-card-text.titulo24Reg.text-center Del siguiente listado, clasifica los gastos según tu consideres si son
              b  gastos fijos
              |  o
              b  gastos variables.
            v-card-text.parrafoDestacadoB.text-center
              | ¡Recuerda!
            v-card-text.parrafoDestacadoB.text-center
              | Gastos fijos: son aquellos que son constantes cada mes y no puedes dejar de pagarlos.
            v-card-text.parrafoDestacadoB.text-center
              | Gastos variables: cambian constantemente en el mes y no son obligatorios
            v-layout.pb-4.ma-0(row, justify-center)
              v-flex(xs12)
                  v-layout(row, flex, align-center)
                    v-flex.px-1(xs6, text-xs-center, align-content-center)
                      v-card.py-0(flat, color='grey lighten-4 ', v-for='(reactivo, index) in reactivos ', :key='index ')
                        v-layout.my-2.text-xs-right(flat)
                          v-flex.py-0.my-0(xs11)
                            v-card-text.pregunta.text-xs-left.text-center
                              | {{reactivo.pregunta}}
                          v-flex.py-3.mr-4.ml-0(xs1, text-xs-start)
                            v-icon(size='15px', v-if='sent && (reactivos[index].resultado==0) ', color='red ') fas fa-times
                            v-icon(size='15px', v-if='sent && (reactivos[index].resultado==1) ', color='green ') fas fa-check
                    v-flex.px-1(xs3, text-xs-center)
                      v-card.py-1(flat, v-for='(reactivo, index) in reactivos ', :key='index ')
                        .selectorBox(v-dragula='reactivos[index].respuesta ', drake='first ')
                          v-card-text.reactivo.text-center.text-uppercase.align-middle(v-for='reactivo in reactivos[index].respuesta ', :key='index ')
                            span {{reactivo}}
                    v-flex.px-1(xs3, text-xs-center)
                      div(v-dragula='respuestas ', drake='first ')
                        v-card.py-1(flat, style='cursor: pointer;', v-for='respuesta in respuestas ', :key='respuesta ')
                          .selectorBox
                            v-card-text.reactivo.text-center.text-uppercase.align-middle
                              | {{respuesta}}
          v-layout(row, justify-center)
            v-flex
              div(v-if='!sent')
                v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', :disabled='respuestas.length!=0 ', @click='sendResult() ')
                  | Enviar
              div(v-if='sent')
                v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                  | Ver Retroalimentación
                v-dialog(v-model='dialog ', persistent, max-width='930px ')
                  v-layout(row, justify-center)
                    v-flex(text-xs-center)
                      v-card
                        .pt-1.pr-2(v-if='sent && (response==1) ')
                          v-layout(row, justify-center)
                            v-flex(text-xs-center)
                              img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
                          v-spacer.my-1.py-4
                          v-card-text.headline
                            | ¡Excelente!
                          v-card.questionCard(flat)
                            v-card-text.dialog_text
                              p.text-sm-left.px-5.my-0
                                | Ya sabes que un Crédito Hipotecario te protege y garantiza que consigas tu meta a pesar de algunos imprevistos.
                                |  ¡Sigue adelante!
                        .pt-1.pr-2(v-if='sent && (response!=1) ')
                          v-layout(row, justify-center)
                            v-flex(text-xs-center)
                              img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
                          v-spacer.my-1.py-4
                          v-card-text.headline
                            | Hay una mejor respuesta...
                          v-card.questionCard(flat)
                            v-card-text.dialog_text
                              p.text-sm-left.px-5.my-0
                                | Tuviste algunos errores, pero no te preocupes, puedes ver el video de nuevo para recordar
                                |  las protecciones de los cinco seguros de tu Crédito Hipotecario.
                              v-layout(row='')
                                v-flex.pt-3.pr-0.pl-5.mr-0.text-xs-left(xs1='')
                                  v-btn.btn_print(fab='', dark='', color='print ', @click.prevent="showVideo = !showVideo")
                                    v-icon(dark='') fas fa-history
                                v-flex(xs11='')
                                  v-card-text.print--text.mx-0.px-5.pt-4.mt-3.parrafoRetro14B.text-xs-left
                                    b(v-if="showVideo") Ocultar Video
                                    b(v-else) Volver a ver Video 
                              .video-responsive(v-if="showVideo")
                                iframe.pa-5(width="420" height="315" src="https://player.vimeo.com/video/287127139" frameborder="0" allowfullscreen)
                              v-card-text.text-xs-left.px-5
                                |  Si deseas continuar, solo recuerda que tu Crédito Hipotecario te protege y garantiza que consigas tu meta a pesar de algunos imprevistos.
                        v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage( 'page10-3') ")
                          | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>
<script>
import {
  eventBus
} from '../main';

function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
}

export default {
  name: 'app',
  deactivated() {
    this.time = 75;
    this.timer = null;
  },
  activated() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if ((this.time > 0) && !this.sent) {
          this.time--
        } else {
          clearInterval(this.timer);
          if (!this.sent) {
            this.sendResult();
            this.nextPage('p05');
          }
        }
      }, 1000)
    }
  },
  data() {
    return {
      reactivos: [{
          pregunta: 'Sufrí un accidente que me dejó con una incapacidad temporal o permanente.',
          correcta: 'SEGURO DE INVALIDEZ',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Mi padre contrató un Crédito Hipotecario y ha fallecido.',
          correcta: 'SEGURO DE VIDA',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'La empresa donde trabajaba se mudó a Canadá y nos liquidaron a todos.',
          correcta: 'SEGURO DE DESEMPLEO',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Hubo un huracán y se inundó mi casa. ',
          correcta: 'SEGURO CONTENIDOS Y DAÑOS',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        }
      ],
      respuestas: [
        "SEGURO DE INVALIDEZ",
        "SEGURO DE VIDA",
        "SEGURO DE DESEMPLEO",
        "SEGURO CONTENIDOS Y DAÑOS"
      ],
      response: 'none',
      show: false,
      dialog: false,
      correcta: false,
      completo: 'none',
      sent: false,
      showVideo: false,
      resultado: 0,
      time: 75,
      timer: null,
      interaction : {
        id : "TCH.L2.p10-2",
        questionText : "Clasifica en gastos fijos o variables",
        learnerResponse: "",
        correctAnswer : "",
        wasCorrect : true
      }
    }
  },
  computed: {
    testComplete() {
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == 'none') {
          this.completo = 'none';
        }
      });
      this.completo = 'true';
    },
    responseIsNone() {
      return {
        'btn-primary': this.response != 'none',
        'btn-secondary': this.response == 'none'
      }
    }
  },
  beforeMount: function() {
    shuffle(this.respuestas);
  },
  beforeUpdate: function() {
    var respuestas = this.respuestas;
    this.reactivos.forEach(function(reactivo) {
      if (reactivo.respuesta.length == 2) {
        if (reactivo.respuesta[0] == reactivo.respuestaUnica) {
          respuestas.push(reactivo.respuesta.shift());
        } else {
          respuestas.push(reactivo.respuesta.pop());
        }
      }
      reactivo.respuestaUnica = reactivo.respuesta[0];
    });
  },
  methods: {
    grade: function(reactivos) {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correcta === reactivo.respuesta[0]) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
      eventBus.$emit('send_suspend_data', this.reactivos);
      this.response = this.resultado;
      // Record interactions
      var interaction = this.interaction;
      interaction.learnerResponse = this.reactivos.map(function (reactivo, index) {
         return (reactivo.respuesta? "Fijo":"Variable")
      });
      eventBus.$emit('record_interaction', interaction)
    },
    created() {
      if ('suspend_data' in this.$parent) {
        if (this.$parent.currentPage in this.$parent.suspend_data) {
          this.reactivos = this.$parent.suspend_data[this.$parent.currentPage];
          this.sendResult();
        }
      }
      console.log('GLOBAL SERVICE: created')
      let service = this.$dragula.$service
      // IMPORTANT!! setup empty named drakes matching
      // directive drake configs in template
      // otherwise may (currently) result in conflict
      service.options('first', {})
      console.log('GLOBAL SERVICE: ready')
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    },
    testValueTrue(value, correct) {
      if (value == 'none') {
        return 'greyNormal'
      }
      if (value == true) {
        if (correct == 'none') {
          return 'accent';
        } else if (correct == 1) {
          return 'accent';
        } else if (correct == 0) {
          return 'red';
        }
      }
      if (value == false) {
        return 'greyNormal'
      }
    },
    testValueFalse(value, correct) {
      if (value == 'none') {
        return 'greyNormal'
      }
      if (value == false) {
        if (correct == 'none') {
          return 'accent';
        } else if (correct == 1) {
          return 'accent';
        } else if (correct == 0) {
          return 'red';
        }
      }
      if (value == true) {
        return 'greyNormal'
      }
    }
  }
};
</script>
